export default __webpack_public_path__ + "handball-pre.png";